import React from 'react';
import { Typography } from '@mui/material';
import { ChevronRight } from '@mui/icons-material';
import styles from './PerformanceCard.module.css';

interface PerformanceCardProps {
  title: string;
  value: string;
  percentageChange: string;
  positive?: boolean;
  blueText?: boolean;
  additionalText?: string;
}

const PerformanceCard: React.FC<PerformanceCardProps> = ({
  title,
  value,
  percentageChange,
  positive = true,
  blueText = false,
  additionalText,
}) => {
  return (
    <div className={styles.performanceCard}>
      <div className={styles.performanceCardHeader}>
        <Typography variant="body1" className={styles.performanceCardTitle}>
          {title}
        </Typography>
        <ChevronRight className={styles.chevronIcon} />
      </div>
      <div className={styles.performanceCardContent}>
        <Typography variant="h4" className={styles.performanceCardValue}>
          {value}
        </Typography>
        {percentageChange ? (
          <Typography
            variant="caption"
            className={positive ? styles.greenText : styles.redText}
            sx={{ justifyContent: 'end' }}
          >
            {percentageChange}
            <img
              src="/icons/arrow-rise.svg"
              alt="Trend indicator"
              className={styles.arrowIcon}
              style={{
                transform: positive ? 'none' : 'rotate(180deg)',
              }}
            />
          </Typography>
        ) : null}
        {additionalText && (
          <Typography variant="caption" className={blueText ? styles.blueText : ''}>
            {additionalText}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default PerformanceCard;
